/** Format approved decimal integer units without converting the balance/amount to Number. */
export const formatBillingUnits = (units: string, scale: number): string => {
  if (!/^(0|[1-9]\d{0,37})$/.test(units) || !Number.isInteger(scale) || scale < 0 || scale > 12)
    return 'Unavailable';
  const padded = units.padStart(scale + 1, '0');
  const whole = scale ? padded.slice(0, -scale) : padded;
  const fraction = scale ? `.${padded.slice(-scale)}` : '';
  return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + fraction;
};

/** Compact credit display without rounding or changing fixed monetary precision. */
export const formatCreditUnits = (units: string, scale: number): string => {
  const [whole, fraction] = formatBillingUnits(units, scale).split('.');
  const significant = fraction?.replace(/0+$/, '');
  return significant ? `${whole}.${significant}` : whole;
};

/** Only the bounded visual percentage is converted to Number; credit values stay exact. */
export const billingRemainingPercent = (remaining: string, granted: string): number | null => {
  if (![remaining, granted].every((value) => /^(0|[1-9]\d{0,37})$/.test(value))) return null;
  const total = BigInt(granted);
  if (total === 0n) return null;
  const left = BigInt(remaining) > total ? total : BigInt(remaining);
  return Number((left * 10000n) / total) / 100;
};

export const formatBillingMoney = (minor: string, currency: string, scale: number): string =>
  `${currency.toUpperCase()} ${formatBillingUnits(minor, scale)}`;

export const billingDate = (value: string | null): string =>
  value && Number.isFinite(Date.parse(value))
    ? new Date(value).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC',
      })
    : 'Unavailable';
